import { normalizeUrl } from 'utils/url';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import {
  CONTACT_US_DEALER,
  FOOTER_LINK_HELP_CENTER
} from 'constants/endpoints';
import { LocationAddress } from 'services/location/types';

interface ContactDealerCommonContentProps {
  dealerAddress: LocationAddress;
  catalogId: string;
  langId: string;
  storeId: string;
  esiteUrl: string;
  isCustomerSupportEnabled: boolean;
}

export const contactDealerCommonContent = ({
  dealerAddress,
  catalogId,
  langId,
  storeId,
  esiteUrl,
  isCustomerSupportEnabled
}: ContactDealerCommonContentProps) => {
  const dealerPhone = dealerAddress?.phone;
  const dealerEmail = dealerAddress?.email;
  const hasAddressInfo = [dealerAddress].some((val) => !!val);
  const addressObj = {
    address1: dealerAddress?.line1,
    city: dealerAddress?.city,
    country: dealerAddress?.country,
    state: dealerAddress?.state,
    zipCode: dealerAddress?.zipCode
  };

  const contactDealerFormLink = normalizeUrl(
    replaceTokensInString(CONTACT_US_DEALER, catalogId, langId, storeId)
  );

  const helpCenterOldFaqLink = normalizeUrl(
    replaceTokensInString(FOOTER_LINK_HELP_CENTER, esiteUrl)
  );

  const contactFormLink = isCustomerSupportEnabled
    ? contactDealerFormLink
    : helpCenterOldFaqLink;

  return {
    dealerPhone,
    dealerEmail,
    hasAddressInfo,
    addressObj,
    contactFormLink
  };
};
